<template>
    <!-- Alphacredit -->
    <div v-if="paymentOptions.filter(x => x.Provider == 'Alphacredit') != null && activePartnumber.Price >= 1999">
        <div class="financing-available clearfix">
            <a class="Alphacredit-learn-more track-GA4-event row" data-ga4_name="financing_prequalify" :data-ga4_model_category="activePartnumber.GA_Category" :data-ga4_model_name="activePartnumber.GA_ModelName" data-ga4_click_text="prequalify now" data-toggle="modal" data-target="#ModalAlphacredit2" style="cursor: pointer;">
                <div class="col-md-8 col-xs-6">{{label}}</div>
                <div class="col-md-4 col-xs-6 text-right"><img :src="cdn + '/Images/Shared/Icons/icon_bnpparibaspf.png'" /></div>
            </a>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="ModalAlphacredit2">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" style="position:absolute; top:10px;right:10px;" data-dismiss="modal">&times;</button>
                        <a href="https://www.giant-bicycles.com/nl/bnp-personal-finance" target="_blank"><img :src="cdn + '/Images/Shared/Icons/icon_bnpparibaspf.png'" /></a>
                    </div>
                    <div class="modal-body">
                        <div class="cf-calculator">
                            <p style="font-size: 12px; line-height:15px;">
                                Betaal in termijnen van 36, 42 of 48 maanden via BNP Paribas Personal Finance. Selecteer het model van je keuze en kies tijdens het checkout proces voor 'Financiering' als betalingsoptie. Mogelijk bij online bestellingen met een totaalbedrag vanaf &euro;1999,-.
                            </p>
                            <p style="font-size: 12px; line-height:15px;">
                                <a href="https://www.giant-bicycles.com/nl/bnp-paribas-personal-finance" target="_blank">Klik hier voor meer informatie over financiering via BNP Paribas Personal Finance.</a>
                            </p>

                            <div class="mobile-wrapper-sizes icon-hand-swipe-container" id="calculator" style="margin: 20px 0;">
                                <div class="visible-xs icon-hand-swipe">
                                    <div class="box"><img class="lazy-loading" :data-src="cdn + '/Images/Shared/icon_hand_swipe.png'" :src="cdn + '/Images/Shared/icon_hand_swipe.png'"></div>
                                </div>
                                <table class="financing" style="min-width:900px;">
                                    <tbody>
                                        <tr class="heading">
                                            <th nowrap>{{getInterfaceText('shop-finance-price')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-deposit')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-amount-of-credit')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-duration')}}<br/>{{getInterfaceText('shop-finance-duration-in-months')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-duration-monthly')}}<br />{{getInterfaceText('shop-finance-duration-rate')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-debit-interest-rate')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-interest-annual')}}</th>
                                            <th nowrap>{{getInterfaceText('shop-finance-debit-total-price')}}</th>
                                        </tr>
                                        <tr v-for="(product, productIndex) in products" :key="productIndex">
                                            <td nowrap>{{decimalToCurrencyFormat(activePartnumber.Price)}}</td>
                                            <td nowrap>&euro; 0,00</td>
                                            <td nowrap>{{decimalToCurrencyFormat(activePartnumber.Price)}}</td>
                                            <td nowrap>{{product.months}}</td>
                                            <td nowrap>{{decimalToCurrencyFormat(CalculateMonthlyPayment(activePartnumber.Price, product.months, 0, 0, product.interestPercentage))}}</td>
                                            <td nowrap>{{product.interestPercentage}} %</td>
                                            <td nowrap>{{product.interestPercentage}} %</td>
                                            <td nowrap>{{decimalToCurrencyFormat(CalculateMonthlyPayment(activePartnumber.Price, product.months, 0, 0, product.interestPercentage) * product.months)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <a href="https://www.giant-bicycles.com/nl/bnp-paribas-personal-finance" class="btn btn-success" target="_blank" style="margin-bottom:20px;">Bekijk hoeveel je kunt lenen</a>
                            <p style="font-size:12px;line-height:15px;color:#555;">
                                BNP Paribas Personal Finance B.V. (kantoorhoudende te Marten Meesweg 97, 3068 AV Rotterdam) treedt op als aanbieder van de genoemde financieringen.
                                Giant treedt op als vrijgestelde bemiddelaar en bemiddelt niet uitsluitend voor BNP Paribas Personal Finance BV. Dit betreft geen advies,
                                je dient zelf te bepalen of het door jouw gewenste krediet aansluit bij je wensen, behoeften en persoonlijke situatie.
                                Verdere informatie over deze kredietmogelijkheid kun je vinden via de website van BNP Paribas Personal Finance.
                                De Europese Standaardinformatie kun je bij ons opvragen. Je krijgt deze altijd voorafgaand aan de totstandkoming van de overeenkomst.
                                Aan deze berekening  kunnen geen rechten worden ontleend.
                            </p>
                            <p>
                                <img :src="cdn + '/Images/Shared/Icons/banner_geldlenenkostgeld.png'" style="width:100%;height:auto;max-width: 400px;" />
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{getInterfaceText('close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../../mixins/general.js';
    export default {
        name: 'Alphacredit',
        mixins: [generalMixin],
        props: ['activePartnumber'],
        data: function () {
            return {
                paymentOptions: window.paymentOptions,
                cdn: window.cdn
            }
        },
        methods: {
            CalculateInterest(interestPercentage) {
                const a = 1 + interestPercentage / 100;
                const b = 1 / 12;
                const result = parseFloat((Math.pow(a, b) - 1).toFixed(15));
                return result;
            },
            CalculateMonthlyPayment(amount, months, type, fv, calcInterest) {
                const interestPercentage = this.CalculateInterest(calcInterest);
                return -fv + amount * Math.pow(1 + interestPercentage, Math.ceil(months)) / (1 + interestPercentage * type) / ((Math.pow(1 + interestPercentage, Math.ceil(months)) - 1) / interestPercentage);
            }
        },
        computed: {
            products() {
                return [
                    { months: 36, interestPercentage: 4.99 },
                    { months: 42, interestPercentage: 4.99 },
                    { months: 48, interestPercentage: 4.99 },
                ];
            },
            label() {
                var translation = this.getInterfaceText("shop_or_finance_from_per_month");
                var prod = this.products[2];
                return translation.replace("{0}", this.CalculateMonthlyPayment(this.activePartnumber.Price, prod.months, 0, 0, prod.interestPercentage).toFixed(2));
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        }
    }
</script>
